import { SendMessageFormContainer } from "components/containers/talktocarrot/SendMessageFormContainer"
import React, { FC } from "react"
import { MemberConnectFailure, PartnerConnectFailure } from "./Failure"

interface PartnerProcessConnectInsuranceFailureContainerProps {
  onExit: () => void
}

const PartnerProcessConnectInsuranceFailContainer: FC<PartnerProcessConnectInsuranceFailureContainerProps> = () => (
  <SendMessageFormContainer
    modalTopic={"ConnectInsuranceError"}
    BenefitEnrollmentView={PartnerConnectFailure}
  />
)

interface ProcessConnectInsuranceFailureContainerProps {
  onExit: () => void
}

const ProcessConnectInsuranceFailContainer: FC<ProcessConnectInsuranceFailureContainerProps> = () => (
  <SendMessageFormContainer modalTopic={"ConnectInsuranceError"} BenefitEnrollmentView={MemberConnectFailure} />
)

export { ProcessConnectInsuranceFailContainer, PartnerProcessConnectInsuranceFailContainer }
